import React from "react";
import AdditionalDetailsFields from "../../../constants/DriverMedals/MetricDetailsFields.json";
import MetricChangeLogsFields from "../../../constants/DriverMedals/MetricChangeLogs.json";
import Textarea from "sushiweb/InputTypes/Textarea";
import Input from "sushiweb/InputTypes/Input";
import variables from "../../../constants/assets/variables";
import { getPath } from "../../../utils";
import NoFooterModal from "../../Common/NoFooterModal";
import ChangeLogList from "../../Common/ChangeLogList";

const DriverMetricDetails = ({ list, handleClose }) => {
  const getValue = (field) => {
    const val = getPath(list, field.key, "");
    return val;
  };

  const getField = (type, field) => {
    switch (type) {
      case "custom":
        return (
          <Textarea
            id="sushi-textarea"
            data-testid={field.id}
            className="mb-20"
            rows={1}
            fullWidth
            disabled
            label={getValue(field.custom_placeholder_key)}
            value={getValue(field)}
          />
        );
      case "textarea":
        return (
          <Textarea
            id="sushi-textarea"
            data-testid={field.id}
            className="mb-20"
            rows={1}
            fullWidth
            disabled
            label={field.placeholder}
            value={getValue(field)}
          />
        );
      case "text":
        return (
          <Input
            borderColor={variables.primaryColor}
            id="sushi-input"
            data-testid={field.id}
            fullWidth
            disabled
            label={field.placeholder}
            value={getValue(field)}
          />
        );
    }
  };

  return (
    <NoFooterModal
      header={true}
      heading="Driver Metrics"
      handleClose={handleClose}
      id="DriverMedalMetricsModal"
    >
      {AdditionalDetailsFields.map((field, index) => {
        return <>{getField(field.type, field)}</>;
      })}
      <ChangeLogList
        changes={list["logs"]}
        tableFields={MetricChangeLogsFields}
      />
    </NoFooterModal>
  );
};

export default DriverMetricDetails;
